export default __webpack_public_path__ + "static/media/unicorn1.b1f8ac79.png";